import { Injectable } from '@angular/core';

@Injectable()
export class PkceService {

    /**
     * Generates a code verifier for PKCE
     * @returns string
     */
    generateCodeVerifier(): string {
        const array = new Uint8Array(32);
        crypto.getRandomValues(array);
        return this.base64URLEncode(array);
    }

    /**
     * Generates a code challenge from the code verifier
     * @param codeVerifier 
     * @returns Promise<string>
     */
    async generateCodeChallenge(codeVerifier: string): Promise<string> {
        const encoder = new TextEncoder();
        const data = encoder.encode(codeVerifier);
        const digest = await crypto.subtle.digest('SHA-256', data);
        return this.base64URLEncode(new Uint8Array(digest));
    }

    /**
     * Base64 URL encode
     * @param buffer 
     * @returns string
     */
    private base64URLEncode(buffer: Uint8Array): string {
        const base64 = btoa(String.fromCharCode(...buffer));
        return base64
            .replace(/\+/g, '-')
            .replace(/\//g, '_')
            .replace(/=/g, '');
    }

    /**
     * Store PKCE values in localStorage
     * @param codeVerifier 
     * @param codeChallenge 
     */
    storePkceValues(codeVerifier: string, codeChallenge: string): void {
        localStorage.setItem('pkce_code_verifier', codeVerifier);
        localStorage.setItem('pkce_code_challenge', codeChallenge);
    }

    /**
     * Get stored code verifier
     * @returns string | null
     */
    getCodeVerifier(): string | null {
        return localStorage.getItem('pkce_code_verifier');
    }

    /**
     * Clear stored PKCE values
     */
    clearPkceValues(): void {
        localStorage.removeItem('pkce_code_verifier');
        localStorage.removeItem('pkce_code_challenge');
    }
}
